export var colors = {
    brand: "#009FE3",
    'light-1': "#FFFFFF",
    'light-2': "#FAFAFA",
    'light-3': "#F1F2F4",
    'light-4': "#9DB5C7",
    'light-5': "#7D7D7D",
    'dark-1': "#0A121B",
    'dark-2': "#112130",
    'dark-3': "#1A2C3F",
    'dark-4': "#243846",
    'dark-5': "#58646E",
    background: {
        dark: "dark-1",
        light: "light-3",
    },
    'background-back': {
        dark: "#0A121B",
        light: "#F1F2F4",
    },
    'background-front': {
        dark: "dark-3",
        light: "light-1",
    },
    'background-contrast': {
        dark: "#132333",
        light: "light-2", // TODO: should be something close to light-2
    },
    text: {
        dark: "#FFFFFF",
        light: "#000000",
    },
    'text-strong': {
        dark: "#FFFFFF",
        light: "#000000",
    },
    'text-weak': {
        dark: "#FFFFFF55",
        light: "#00000088",
    },
    'text-xweak': {
        dark: "#FFFFFF44",
        light: "#00000077",
    },
    border: {
        light: "background",
        dark: "background",
    },
    control: {
        dark: "light-1",
        light: "dark-1",
    },
    'active-background': "background-contrast",
    'active-text': {
        light: "text-strong",
        dark: "text-strong",
    },
    'selected-background': {
        light: "light-2",
        dark: "dark-2",
    },
    'selected-text': {
        light: "text-strong",
        dark: "text-strong",
    },
    'status-critical': "#F45052",
    'status-error': "#FF9900",
    'status-warning': "#EDC538",
    'status-ok': "#179D5D",
    'status-unknown': {
        light: "#D7E2E6",
        dark: "#2A3E4F",
    },
    'status-disabled': {
        light: "#FFFFF50",
        dark: "#0000050",
    },
    icon: {
        light: "dark-1",
        dark: "light-1",
    },
    focus: "brand",
    'graph-0': "brand",
    'graph-1': "status-unknown",
    'graph-2': "status-critical",
    'electric-indigo': "#7100FF",
    'vivid-gamboge': "#FF9702",
    'bright-turquoise': "#12EED3",
};
//# sourceMappingURL=colors.js.map